import { Component, Vue, Watch, Ref } from 'vue-property-decorator'
import { isNull } from 'lodash'
import {
  CalendarVO,
  CalendarServiceProxy,
  CalendarSimpleVO,
  CalendarDTO,
  CalendarUpdateDTO,
} from '@/service-proxies/app-v2/time.service-proxies'
import CalendarTable from './components/CalendarTable'
import CalendarGroup from './components/CalendarGroup.vue'
import FastSelect from './components/FastSelect.vue'
import InfoForm from './components/InfoForm'
import ConfigureTree from './components/ConfigureTree.vue'
import { state, actions } from './store'
import './index.less'
import dayjs from 'dayjs'
import { Reactive } from '@/utils/decorators'
import { oldTenants } from './utils'
import { getUserInfo } from '@/utils/auth'
const csp = new CalendarServiceProxy()

@Component
export default class ProductionCalendar extends Vue {
  @Ref() infoForm: InfoForm
  @Ref() configureTree
  @Ref() calendarGroup

  @Reactive(state) readonly shiftList = []
  @Reactive(state) readonly year = 0
  @Reactive(state) readonly calendarList: CalendarSimpleVO[] = []
  @Reactive(state) readonly currentCalendarId: string = ''
  @Reactive(state) readonly currentCalendarDetail: CalendarVO = null
  @Reactive(state) readonly loading = null
  @Reactive(state) readonly visible = null

  body = {
    codeRuleId: '',
    code: '',
    year: '',
    name: '',
    dateDTOList: [
      {
        calendarDate: '',
        modelId: '',
      },
    ],
  }

  selectedRowKeys = []
  printVisible =false
  dataList = []
  selectId = ""

  get canUpdateOrDelete() {
    return !!this.currentCalendarId
  }

  @Watch('currentCalendarId')
  setCurrentCalendarDetail(val) {
    if (!val) {
      actions.setCalendarDetail(null)
    }
    actions.loadCalendarDetail()
  }

  @Watch('calendarList')
  handleCalendarList(val) {
    if (val[0]) {
      this.onClickRow(val[0])
    }
  }

  created() {
    actions.loadShiftList().then(() => {
      actions.loadCalendarList()
    })
  }

  beforeDestroy() {
    actions.setCurrentCalendarId('')
    actions.setCalendarDetail(null)
  }

  onSelectChange(selectedRowKeys) {
    // console.log(11111,selectedRowKeys)
    this.selectedRowKeys = selectedRowKeys;
  }

  printing() {
    this.getData()
    this.printVisible = true
  }

  cancel() {
    this.selectedRowKeys = []
    this.printVisible = false
  }
  handlerPrint() {
    this.selectedRowKeys = []
    this.printVisible = false
  }


  getData() {
    this.dataList = []
    this.selectedRowKeys.map(id =>{
      this.calendarList.map(item => {
        if(id === item.id) {
          this.dataList.push({
            code: item.code,
            name: item.name
          })
        }
      })
    })
  }

  async createCalendar() {
    const {codeRuleId, code, name, year, status } = this.infoForm.body
    const temp = this.calendarList.filter(item => item.code === code)
    let others = []
    for (let item of temp) {
      const res = await csp.getCalendarDetail(item.id)
      const tmp = res.calendarDayVOList.filter(item =>
        [`${year - 1}-12-30`, `${year - 1}-12-31`, `${year + 1}-01-01`, `${year + 1}-01-02`].includes(
          dayjs(item.calendarDate).format('YYYY-MM-DD')
        )
      )
      others = others.concat(tmp)
    }
    const dateDTOList = this.calendarGroup.collectData(others)
    if (!dateDTOList) {
      this.$message.error(this.$t('page_console_calendar_no_close'))
      return
    }
    if (!name) {
      this.$message.error(this.$t('page_calendar_complete'))
      return
    }
    if (dateDTOList?.length === 0) {
      this.$message.error(this.$t('page_calendar_select'))
      return
    }
    const body = {
      codeRuleId,
      code,
      name,
      year,
      status: status ? 1 : 0,
      dateDTOList: dateDTOList.map(item => ({
        ...item,
        calendarDate: new Date(dayjs(item.calendarDate).valueOf()),
      })),
    } as CalendarDTO
    console.log(this.body)
    actions.setLoading({ createForm: true })
    try {
      const { tenant_id } = getUserInfo()
      if (oldTenants.includes(tenant_id)) {
        await csp.saveYearCalendar(body)
      } else {
        await csp.saveCalendar(body)
      }
      actions.setLoading({ createForm: false })
      this.$message.success(this.$t('page_resource_pool_success'))
      actions.setVisible({ createForm: false })
      await actions.loadCalendarList()
    } catch (e) {
      actions.setLoading({ createForm: false })
    }
  }

  async updateCalendar() {
    const { id, name, status } = this.infoForm.body
    const dateDTOList = this.calendarGroup.collectData()
    if (!dateDTOList) {
      this.$message.error(this.$t('page_console_calendar_no_close'))
      return
    }
    if (!name) {
      this.$message.error(this.$t('page_calendar_complete'))
      return
    }
    if (dateDTOList?.length === 0) {
      this.$message.error(this.$t('page_calendar_select'))
      return
    }
    const body = {
      id,
      dateDTOList: dateDTOList.map(item => ({
        ...item,
        calendarDate: new Date(dayjs(item.calendarDate).valueOf()),
      })),
    } as CalendarUpdateDTO
    console.log(this.body)
    actions.setLoading({ updateForm: true })
    try {
      await Promise.all([csp.updateCalendar(body), csp.rename(id, name, status ? 1 : 0)])
      this.loading.update = false
      actions.setLoading({ updateForm: false })
      this.$message.success(this.$t('page_resource_pool_success'))
      actions.setVisible({ updateForm: false })
      await actions.loadCalendarList()
      await actions.loadCalendarDetail()
    } catch (e) {
      actions.setLoading({ updateForm: false })
    }
  }

  async updateConfigure() {
    actions.setLoading({ configureForm: true })
    const bool = this.configureTree.save()
    actions.setLoading({ configureForm: false })
    if(!bool) return
    actions.setVisible({ configureForm: false })
  }

  onClickRow(record){
    this.selectId = record.id
    this.selectedRowKeys = [record.id]
  }

  render() {
    const header = () => (
      <div>
        <a-button type="primary" style="margin-right: 8px" onClick={() => actions.setVisible({ createForm: true })}>
          {this.$t('create')}
        </a-button>
        <a-button type="default" disabled={this.selectedRowKeys.length === 0} style="margin-right: 8px;" onClick={() =>this.printing()}>{this.$t("page_print_code")}</a-button>
        <code-model
        visible={this.printVisible}
        onCancel={this.cancel}
        dataList={this.dataList}
        onprint={this.handlerPrint}
        >
        </code-model>
      </div>
    )

    const left = () => <CalendarTable onOnSelectChange={value => this.onSelectChange(value) } selectedRowKeys={this.selectedRowKeys} onClickRow={value => this.onClickRow(value) } selectId={this.selectId}/>

    const right = () =>
      !isNull(this.currentCalendarDetail) ? (
        <div style="height: 100%; display: flex; flex-direction: column">
          <div style="padding: 8px; ">
            <a-spin spinning={this.loading.calendarDetail} style="height: 100%">
              <a-row type="flex" align="middle" style="margin-bottom: 8px">
                <a-col span={24}>
                  <a-button type="primary" onClick={() => actions.setVisible({ configureForm: true })}>
                    {this.$t('page_console_calendar_batch_configuration_station')}
                  </a-button>
                </a-col>
                <a-col span={24}>
                  <general-title>{this.$t('page_console_calendar_detail')}</general-title>
                </a-col>
                <a-col span={12}>
                  <span style="font-weight: 700">{this.$t('page_calendar_c_code')}</span>：
                  {this.currentCalendarDetail.code}
                </a-col>
                <a-col span={12}>
                  <span style="font-weight: 700">{this.$t('page_calendar_c_name')}</span>：
                  {this.currentCalendarDetail.name}
                </a-col>
              </a-row>
            </a-spin>
          </div>
          <div style="height: 100%; padding: 8px; background: #fff">
            <a-spin spinning={this.loading.calendarDetail} style="height: 100%">
              <general-title>{this.$t('page_console_calendar_summary')}</general-title>
              <CalendarGroup
                editable={false}
                year={this.currentCalendarDetail.year}
                days={this.currentCalendarDetail.calendarDayVOList}
                shiftList={this.shiftList}
              />
            </a-spin>
          </div>
        </div>
      ) : null

    const createModal = (
      <a-modal
        v-model={this.visible.createForm}
        title={this.$t('page_calendar_template')}
        width={1200}
        destroyOnClose
        confirmLoading={this.loading.createForm}
        maskClosable={false}
        onOk={this.createCalendar}
      >
        <InfoForm ref="infoForm" visable={this.visible.createForm}/>
        <CalendarGroup
          ref="calendarGroup"
          year={this.year}
          days={[]}
          editable={true}
          shiftList={this.shiftList}
          detail={this.currentCalendarDetail}
        />
        <FastSelect
          year={this.year}
          shiftList={this.shiftList}
          onSelectWorkday={() => this.calendarGroup.collectData()}
        />
      </a-modal>
    )

    const updateModal = (
      <a-modal
        v-model={this.visible.updateForm}
        title={this.$t('page_calendar_template')}
        width={1200}
        destroyOnClose
        confirmLoading={this.loading.updateForm}
        maskClosable={false}
        onOk={this.updateCalendar}
      >
        <InfoForm ref="infoForm" data={this.currentCalendarDetail} />
        <CalendarGroup
          ref="calendarGroup"
          year={this.year}
          days={this.currentCalendarDetail?.calendarDayVOList}
          shiftList={this.shiftList}
          editable={true}
          detail={this.currentCalendarDetail}
        />
        <FastSelect
          year={this.year}
          shiftList={this.shiftList}
          onSelectWorkday={() => this.calendarGroup.collectData()}
        />
      </a-modal>
    )

    const configureModal = (
      <a-modal
        v-model={this.visible.configureForm}
        title={this.$t('page_console_calendar_batch_configuration_station')}
        width={900}
        destroyOnClose
        confirmLoading={this.loading.configureForm}
        maskClosable={false}
        onOk={this.updateConfigure}
      >
        <ConfigureTree ref="configureTree" calendar={this.currentCalendarDetail}></ConfigureTree>
      </a-modal>
    )

    const _default = () => [createModal, updateModal, configureModal]

    return (
      <general-layout
        leftStyle={{ width: '500px' }}
        bodyStyle={{ height: 'calc(100% - 48px)' }}
        scopedSlots={{ header, left, right, default: _default }}
      />
    )
  }
}
